import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseQueryParams, IResponsePaginateRaw, WithMetadata } from '@/types';
import { DynaDocsModel, DynaDocsModelDto } from '@/types/dyna-docs-model.types';

@Injectable({ providedIn: 'root' })
export class DynaDocsModelsService {
  BASEURL = `${environment.api.paramsUrl}/dyna-docs-models`;
  httpClient = inject(HttpClient);

  getAll(params?: BaseQueryParams): Observable<IResponsePaginateRaw<DynaDocsModel>> {
    let httpParams = new HttpParams();
    if (params?.page !== undefined) httpParams = httpParams.set('page', params.page.toString());
    if (params?.size !== undefined) httpParams = httpParams.set('size', params.size.toString());
    if (params?.sort) httpParams = httpParams.set('sort', params.sort);
    if (params?.search) httpParams = httpParams.set('search', params.search);
    return this.httpClient.get<IResponsePaginateRaw<DynaDocsModel>>(this.BASEURL, { params: httpParams });
  }

  getAllActives(params?: BaseQueryParams): Observable<DynaDocsModel[]> {
    let httpParams = new HttpParams();
    if (params?.search) {
      httpParams = httpParams.set('search', params.search);
    }
    return this.httpClient.get<DynaDocsModel[]>(`${this.BASEURL}/active-list`, { params: httpParams });
  }

  getOne(id: number): Observable<WithMetadata<DynaDocsModel>> {
    return this.httpClient.get<WithMetadata<DynaDocsModel>>(`${this.BASEURL}/${id}`);
  }

  create(dto: DynaDocsModelDto): Observable<WithMetadata<DynaDocsModel>> {
    return this.httpClient.post<WithMetadata<DynaDocsModel>>(this.BASEURL, dto);
  }

  update(id: number, dto: DynaDocsModelDto): Observable<WithMetadata<DynaDocsModel>> {
    return this.httpClient.put<WithMetadata<DynaDocsModel>>(`${this.BASEURL}/${id}`, dto);
  }

  delete(id: number): Observable<{ status: number; message: string }> {
    return this.httpClient.delete<{ status: number; message: string }>(`${this.BASEURL}/${id}`);
  }

  getList(): Observable<DynaDocsModel[]> {
    return this.httpClient.get<DynaDocsModel[]>(`${this.BASEURL}/list`);
  }

  getListByAo(aoId: number): Observable<DynaDocsModel[]> {
    return this.httpClient.get<DynaDocsModel[]>(`${this.BASEURL}/by-appel-offre/${aoId}`);
  }
}
